/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.30",
    versionName: "0.2.0-nightly.2026.3.30",
    versionChannel: "nightly",
    buildDate: "2026-03-30T00:13:39.456Z",
    commitHash: "f58a0211ad90c7f925cd6526882012265edd4594",
};
